import React, { useEffect, useRef, useState } from 'react';
import '../styles/HomeSlot2.css';
import slot2 from '../assets/slot2.png';

const HomeSlot2 = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const textEl = textRef.current;
    const imageEl = imageRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (textEl) observer.observe(textEl);
    if (imageEl) observer.observe(imageEl);

    return () => {
      if (textEl) observer.unobserve(textEl);
      if (imageEl) observer.unobserve(imageEl);
    };
  }, []);

  return (
    <section className="home-slot2">
      <div className="home-slot2-content">
        {/* TEXT ON LEFT */}
        <div
          ref={textRef}
          className={`home-slot2-text ${inView ? 'fade-left' : ''}`}
        >
          <ul className="bullet-points">
            <li>SOS safety button</li>
            <li>Live location sharing</li>
            <li>Instant Cash Payments</li>
            <li>Direct booking without Sending or accepting request</li>
          </ul>
          <a
        href="https://play.google.com/store/apps/details?id=com.shade.app"
        className="download-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        Download App
    </a>

        </div>

        {/* IMAGE ON RIGHT */}
        <div
          ref={imageRef}
          className={`home-slot2-image ${inView ? 'fade-right' : ''}`}
        >
          <img src={slot2} alt="Commuting Illustration" />
        </div>
      </div>
    </section>
  );
};

export default HomeSlot2;
